import { ComponentPropsWithoutRef, Dispatch, SetStateAction, useEffect, useState } from 'react'

import clsx from 'clsx'
import { Control, useController } from 'react-hook-form'

export interface SelectType extends ComponentPropsWithoutRef<'select'> {
	name: string
	label: string
	hideLabel?: boolean
	errored?: boolean
	control?: Control
	rules?: any
	hintText?: string | null
	setShowWebsiteField?: Dispatch<SetStateAction<boolean>>
}

export function TrialSelect({
	name,
	label,
	children,
	errored,
	hideLabel,
	control,
	rules,
	hintText,
	setShowWebsiteField,
	...props
}: SelectType) {
	const {
		field: { onChange, onBlur, name: fieldName },
		fieldState: { error }
	} = useController({
		name,
		control,
		rules,
		defaultValue: props.defaultValue ?? ''
	})

	const [isInputActive, setIsInputActive] = useState(false)
	const [inputValue, setInputValue] = useState('')

	useEffect(() => {
		if (props.defaultValue) {
			setIsInputActive(true)
			setInputValue(props.defaultValue.toString())
		}
	}, [props.defaultValue])

	const handleInputChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
		const inputValue = event.target.value
		setIsInputActive(true)
		setInputValue(inputValue)
		onChange(event)
		if (event.target.name === 'currentWebsite' && setShowWebsiteField) {
			if (inputValue === 'yes') {
				setShowWebsiteField(true)
			} else {
				setShowWebsiteField(false)
			}
		}
	}

	const handleBlur = () => {
		onBlur()
		setIsInputActive(false)
	}

	return (
		<div>
			<div className="flex flex-col relative">
				<label
					htmlFor={fieldName}
					className={clsx(
						'absolute transition-all text-gray-600',
						isInputActive || inputValue
							? '-top-4 text-[11px] text-bold'
							: 'bottom-0 peer-focus-within:-top-6 text-base pointer-events-none',
						rules.required ? 'required' : ''
					)}
				>
					{label}
				</label>
				<select
					id={fieldName}
					name={fieldName}
					onChange={handleInputChange}
					onBlur={handleBlur}
					onFocus={() => setIsInputActive(true)}
					{...props}
				>
					<option></option>
					{children}
				</select>

				{/* Dropdown arrow */}
				<svg
					className="absolute pointer-events-none right-0 bottom-[16px]"
					width="12"
					height="7"
					viewBox="0 0 12 7"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path d="M12.0001 0.746454L6.34326 6.40331L0.686408 0.746454H12.0001Z" fill="#121118" />
				</svg>

				{/* Bottom black bar */}
				<div className="border-b border-bc-black" />
			</div>

			{hintText && <p className="text-xs text-gray-600">{hintText}</p>}

			{!!error?.message && <p className="text-xs text-bc-pink">{error.message}</p>}
		</div>
	)
}
